import script from "./CommentElement.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentElement.vue?vue&type=script&setup=true&lang=js"

import "./CommentElement.vue?vue&type=style&index=0&id=aaa61f28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaa61f28"]])

export default __exports__